import FooterZodiacIconCycle from './FooterZodiacIconCycle/FooterZodiacIconCycle';
import FooterConnect from './FooterConnect/FooterConnect';
import FooterSubscribe from './FooterSubscribe/FooterSubscribe';
import FooterCopyright from './FooterCopyright/FooterCopyright';
import styles from './Footer.module.css';

const Footer = () => {
  return (
    <footer className={styles.footerWrapper}>
      <div className={styles.footerContent}>
        <div className={styles.logoContainer}>
          <FooterZodiacIconCycle />
        </div>
        <div className={styles.connectContainer}>
          <FooterConnect />
        </div>
        <div className={styles.subscribeContainer}>
          <FooterSubscribe />
        </div>
      </div>
      <FooterCopyright />
    </footer>
  );
};

export default Footer;
